import React from "react";
import CnicVerificationList from "./CnicVerificationList";
import AddUpdateCnicVerificationPage from "./AddUpdateCnicVerificationPage";
import {
  IIdValuePairResponse,
  ICustomerPageState,
  ICnicVerificationPageProp,
} from "interfaces/Index";
import HeadingText from "components/common/HeadingText/HeadingText";
import {
  CNIC_LISTNG_FILTER,
  CNIC_STATUS,
  CNIC_VERIFICATION_FILTER,
} from "config/constants";
import { Row, Col } from "reactstrap";
import "./CnicVerificationPage.scss";

export default class CnicVerificationPage extends React.Component<
  ICnicVerificationPageProp,
  ICustomerPageState
> {
  constructor(props: ICnicVerificationPageProp) {
    super(props);
    this.state = {
      isEdit: false,
      showUpdatePage: false,
      selectedCnicVerification: null,
      listingFilter: CNIC_LISTNG_FILTER[0],
      selectedCity: null,
      selectedCustomerChannel: null,
      searchText: "",
      currentListPosition: 0,
    };
  }

  fetchDataOnChangeOfListingFilter = (
    city: IIdValuePairResponse,
    customerChannel: IIdValuePairResponse
  ) => {
    if (city && customerChannel) {
      this.props.fetchCnicVerificationData({
        status: CNIC_STATUS.PENDING,
        cityId: city.id,
        customerChannel: customerChannel.id,
      });
    } 
    // else if (city) {
    //   this.props.fetchCnicVerificationData({
    //     status: CNIC_STATUS.PENDING,
    //     cityId: city.id,
    //   });
    // } 
    
    // else if (customerChannel) {
    //   this.props.fetchCnicVerificationData({
    //     status: CNIC_STATUS.PENDING,
    //     customerChannel: customerChannel.id,
    //   });
    // }
  };

  changeListingFilter = (
    filerSelection: IIdValuePairResponse,
    filterType: string
  ) => {
    switch (filterType) {
      case CNIC_VERIFICATION_FILTER.LISTING.valueOf():
        this.setState({ listingFilter: filerSelection });
        break;

      case CNIC_VERIFICATION_FILTER.CITIES.valueOf():
        this.fetchDataOnChangeOfListingFilter(
          filerSelection,
          this.state.selectedCustomerChannel
        );
        this.setState({ selectedCity: filerSelection });
        break;
      case CNIC_VERIFICATION_FILTER.CUSTOMER_CHANNEL.valueOf():
        this.fetchDataOnChangeOfListingFilter(
          this.state.selectedCity,
          filerSelection
        );
        this.setState({ selectedCustomerChannel: filerSelection });
        break;
    }
  };

  componentDidMount = () => {
    this.props.fetchCities();
  };

  componentDidUpdate = (prevProps: ICnicVerificationPageProp) => {
    if (
      prevProps.citiesList &&
      prevProps.citiesList.length === 0 &&
      this.props.citiesList.length > 0
    ) {
      this.setState({ selectedCity: this.props.citiesList[0] });
      this.props.fetchCnicVerificationData({
        status: CNIC_STATUS.PENDING,
        cityId: this.props.citiesList[0].id,
        customerChannel: this.state.selectedCustomerChannel.id,
      });
    }
  };

  toggleAddUpdateCnicVerificationPage = (
    isEdit: boolean = false,
    selectedCnicVerification: any = null,
    searchText: string = "",
    currentScroll: number = 0
  ) => {
    const { showAddUpdatePage } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isEdit: isEdit,
      selectedCnicVerification: selectedCnicVerification,
      count: 0,
      searchText: searchText,
      currentListPosition: currentScroll,
    });
  };

  navigateBackToListingPage = (isAddUpdate: boolean) => {
    const { showAddUpdatePage, searchText, currentListPosition } = this.state;
    this.setState({
      showAddUpdatePage: !showAddUpdatePage,
      isCnicVerificationAddUpdate: isAddUpdate,
      searchText: isAddUpdate ? "" : searchText,
      currentListPosition: isAddUpdate ? 0 : currentListPosition,
    });

    const { selectedCity } = this.state;
    if (selectedCity) {
      // this.props.fetchCnicVerificationData({
      //   status: CNIC_STATUS.PENDING,
      //   cityId: selectedCity.id,
      //   customerChannel: this.state.selectedCustomerChannel.id,
      // });
    }
  };

  renderCnicVerificationUpdatePage = () => {
    const {
      isLoading,
      isError,
      error,
      history,
      location,
      match,
      verifyCnicData,
      isCnicVerified,
      fetchCnicVerificationData,
    } = this.props;

    const { isEdit, selectedCnicVerification } = this.state;
    return (
      <AddUpdateCnicVerificationPage
        backButtonHandler={this.navigateBackToListingPage}
        fetchCnicVerificationData={fetchCnicVerificationData}
        verifyCnicData={verifyCnicData}
        isLoading={isLoading}
        isError={isError}
        error={error}
        isCnicVerificationDataUpdated={isCnicVerified}
        isEdit={isEdit}
        history={history}
        location={location}
        match={match}
        cnicVerificationData={selectedCnicVerification}
      />
    );
  };

  updateCount = (count: number) => {
    this.setState({ count });
  };
  renderCnicVerificationListingPage = () => {
    const {
      error,
      fetchCnicVerificationData,
      cnicVerificationData,
      isCnicVerificationDataFetched,
      isCnicVerificationDataFetchedError,
      isCnicVerified,
      citiesList,
      isCityListFetched,
      pagination,
    } = this.props;
    const { isCnicVerificationAddUpdate, searchText, currentListPosition } =
      this.state;
    return (
      <>
        <section className="main-heading-margin">
          <Row>
            <Col lg="10">
              <HeadingText text="CNIC Verification" isMainHeading={true} />
            </Col>

            <Col lg="2">
              {cnicVerificationData.length > 0 && (
                <div className="count-container">
                  <div className="count-number">{this.state.count}</div>
                  <div className="count-label">PENDING</div>
                </div>
              )}
            </Col>
          </Row>
        </section>
        <CnicVerificationList
          fetchCnicVerificationData={fetchCnicVerificationData}
          cnicVerificationData={cnicVerificationData}
          isLoading={isCnicVerificationDataFetched}
          isError={isCnicVerificationDataFetchedError}
          addUpdatePageHandler={this.toggleAddUpdateCnicVerificationPage}
          error={error}
          isCnicVerificationDataFetched={isCnicVerificationDataFetched}
          isVerificationDataAddedorUpdated={isCnicVerificationAddUpdate}
          isCnicVerificationDataFetchedError={
            isCnicVerificationDataFetchedError
          }
          isCnicVerified={isCnicVerified}
          updateCount={this.updateCount}
          changeListingFilter={this.changeListingFilter}
          listingFilter={this.state.listingFilter}
          citiesList={citiesList}
          isCityListFetched={isCityListFetched}
          selectedCity={this.state.selectedCity}
          selectedCustomerChannel={this.state.selectedCustomerChannel}
          retainedSearchText={searchText}
          pagination={pagination}
          currentListPosition={currentListPosition}
        />
      </>
    );
  };
  render() {
    const { showAddUpdatePage } = this.state;
    return (
      <div>
        {showAddUpdatePage
          ? this.renderCnicVerificationUpdatePage()
          : this.renderCnicVerificationListingPage()}
      </div>
    );
  }
}
